<template>
    <div class="QrCode">
        <canvas
            v-show="!renderFailed"
            ref="canvasEl"
            class="QrCode__canvas"
            data-test-id="QrCode__canvas"
            role="img"
            :aria-label="ariaLabel"
        />
    </div>
</template>

<script lang="ts">
    import QRCode from 'qrcode';
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

    @Component({
        emits: [ 'render-error' ],
    })
    export default class QrCode extends Vue {
        /** The string encoded into the code -- in practice a URL, but any text works. */
        @Prop({ type: String, required: true })
        private content!: string;

        @Prop({ type: Number, default: 220 })
        private size!: number;

        @Prop({ type: String, default: 'Scan this QR code to continue on your mobile device' })
        private ariaLabel!: string;

        private renderFailed: boolean = false;

        private mounted() {
            this.drawCode();
        }

        @Watch('content')
        private onContentChange() {
            this.drawCode();
        }

        // Not named `render`: Vue treats a component method of that name as its render function.
        private async drawCode(): Promise<void> {
            const canvas = this.$refs.canvasEl as HTMLCanvasElement | undefined;

            if (!canvas || !this.content) {
                return;
            }

            try {
                await QRCode.toCanvas(canvas, this.content, {
                    width: this.size,
                    margin: 1,
                    errorCorrectionLevel: 'M',
                });
                this.renderFailed = false;
            } catch (error) {
                this.renderFailed = true;
                this.$emit('render-error', error);
            }
        }
    }
</script>

<style lang="less">
    .QrCode {
        display: flex;
        justify-content: center;

        &__canvas {
            max-width: 100%;
            height: auto;
        }
    }
</style>
